
export interface PeriodTranslation {
  title: string;
}


export class Period {
  id?: number;
  translations: { [key: string]: PeriodTranslation };
  start_date?: string;
  end_date?: string;

  constructor(
    translations: { [key: string]: PeriodTranslation } = {},
    start_date?: string,
    end_date?: string
  ) {
    this.translations = translations;
    this.start_date = start_date;
    this.end_date = end_date;
  }

}
